import React from 'react';
import { navigate } from 'gatsby';
import { Label } from '@nooz-optics/nooz-components-lib';
import { Image } from '../../UI/Media/Image/index';
import { Form } from '../../UI/Forms/Form/form';
import {
  formatContentfulComponentProps,
  returnLocalisedPath,
} from '../../../utils/globals';
import { Button } from '../../UI/Elements';

export const AuthLayout = ({ image, form, help, locale }) => {
  const { label, subLabel, button } = formatContentfulComponentProps(help);
  return (
    <div className='w-screen'>
      <main>
        {/* Contact Section */}
        <div className='relative'>
          <div className='lg:absolute lg:inset-0'>
            <div className='lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2'>
              {image && (
                <Image
                  {...image}
                  objectFit='cover'
                  height='100%'
                  width='100%'
                />
              )}
            </div>
          </div>
          <div className='relative py-16 px-4 sm:py-24 sm:px-6 lg:px-8 lg:max-w-7xl lg:mx-auto lg:py-32 lg:grid lg:grid-cols-2'>
            <div className='lg:pr-8'>
              <div className='max-w-md mx-auto sm:max-w-lg lg:mx-0'>
                <Form {...form} />
              </div>
            </div>
          </div>
        </div>
        {/* CTA Section */}
        {help && (
          <div className='bg-gray-400 text-white'>
            <div className='max-w-md mx-auto text-left py-16 px-4 sm:max-w-5xl sm:py-24 sm:px-6 lg:px-8 lg:py-32'>
              <Label
                {...label}
                size='4xl'
                weight='bold'
                text={label?.text}
              />
              <div className='border-b border-white my-2' />
              {subLabel && (
                <Label
                  {...subLabel}
                  text={subLabel.text}
                />
              )}
              <div className='pt-10'>
                <Button
                  {...button}
                  onClick={() =>
                    navigate(returnLocalisedPath(locale[0], button.slug.url))
                  }
                  size='base'
                  type='white'
                  color={{ classname: 'black' }}
                  label={{ text: button.label?.text }}
                />
              </div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};
